import { CheckCircle2, CircleAlert, Save } from "lucide-react"
import { useTranslation } from "react-i18next"

import type { AgentHistory } from "@/types"

export interface AgentPublicationStatusProps {
  history: AgentHistory
  latestVersionNumber?: number
  publishedVersionNumber?: number
  hasPublishedVersion: boolean
  dirty: boolean
}

export const AgentPublicationStatus = ({
  history,
  latestVersionNumber,
  publishedVersionNumber,
  hasPublishedVersion,
  dirty,
}: AgentPublicationStatusProps) => {
  const { t } = useTranslation()
  const pending = !dirty && !history.wasPublished
  const title = dirty
    ? "unsaved"
    : history.wasPublished
      ? "published"
      : history.versionNumber === latestVersionNumber
        ? "pending"
        : "unpublishedVersion"
  const description = dirty
    ? "saveBeforePublish"
    : history.wasPublished
      ? "liveVersion"
      : publishedVersionNumber != null
        ? "previousLiveVersion"
        : hasPublishedVersion
          ? "previousLive"
          : "notLive"
  const Icon = dirty ? Save : pending ? CircleAlert : CheckCircle2

  return (
    <div role="status" aria-live="polite" className="min-w-0 space-y-1">
      <div
        className={`flex items-center gap-2 text-sm font-medium ${
          pending ? "text-amber-800 dark:text-amber-300" : "text-foreground"
        }`}
      >
        <Icon className="size-4 shrink-0" aria-hidden="true" />
        <span>{t(`workspace.agentPlayground.publication.${title}`)}</span>
      </div>
      <p className="text-xs leading-relaxed text-muted-foreground">
        {t(`workspace.agentPlayground.publication.${description}`, {
          version: history.wasPublished
            ? history.versionNumber
            : publishedVersionNumber,
        })}
      </p>
    </div>
  )
}
